<template>
  <div class="wrap">
    <div class="statisticsTop">
      <div class="left-date">{{ date }}</div>
      <div class="title">青岛环境医院环保产业信息化服务平台</div>
      <div class="time-clock">
        <!-- {{ time }} -->
        <div class="time-clock-wrapper">
          <span class="time" id="time">
            <span class="date">{{ nowTime }}</span>
            <span class="hour"></span>
            <a class="split">:</a>
            <span class="minitus"></span>
            <a class="split">:</a>
            <span class="seconds"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="statisticsCenter">
      <div class="left">
        <div class="leftTop">
          <div class="left-title subTitleBlue">累计数据</div>
          <div class="infoBox">
            <div class="infoBox-left">
              <span class="white">用户总数</span>
              <span class="num">{{ userAmount }}</span>
            </div>
            <div>
              <span class="white">线上问诊次数</span>
              <span class="num">{{ olConsultation }}</span>
            </div>
          </div>
        </div>
        <div class="leftCenter">
          <div class="left-title subTitleBlue">线上访问数量统计</div>
          <div class="infoBox">
            <div class="infoBox-left">
              <span class="white">访问数量统计</span>
              <span class="num">{{ totalVisits }}</span>
            </div>
            <div>
              <span class="white">本月访问数量</span>
              <span class="num">{{ currentMonthVisits }}</span>
            </div>
          </div>
        </div>
        <div class="leftFooter">
          <div class="left-title subTitleBlue">线上访问动态</div>
          <div class="visit-time-picker-wrap">
            <el-date-picker
              class="visit-time-picker"
              @change="changeVisits"
              v-model="visits"
              type="year"
              placeholder="选择年份"
              value-format="yyyy"
              :picker-options="pickerOptionsYear"
              style="
                width: 120px;
                height: 30px;
                backgound-color: #00e4ff;
                font-size: 16px;
              "
            >
              <!-- 选择器图标在右边就启用它 -->
              <!-- prefix-icon="prefix-icon-class" -->
            </el-date-picker>
          </div>

          <div class="chart" id="olVisitChart"></div>
        </div>
      </div>
      <div class="right">
        <div class="right_top">
          <div class="right_top_one">
            <div class="left-title subTitleBlue">注册用户</div>
            <div class="user-time-picker-wrap">
              <el-date-picker
                class="user-time-picker"
                @change="changeRegisterUser"
                v-model="registerUser"
                type="month"
                placeholder="选择月份"
                value-format="yyyy-MM"
                :picker-options="pickerOptionsMonth"
                style="
                  width: 120px;
                  height: 30px;
                  backgound-color: #00e4ff;
                  font-size: 16px;
                "
              >
                <!-- 选择器图标在右边就启用它 -->
                <!-- prefix-icon="prefix-icon-class" -->
              </el-date-picker>
            </div>
            <div id="userChart" class="chart"></div>
          </div>
          <div class="right_top_two">
            <div class="left-title subTitleBlue">访问者类别</div>
            <div id="visiterType" class="chart"></div>
          </div>
          <div class="right_top_three">
            <div class="left-title subTitleBlue">成员单位数量</div>
            <div></div>
            <div class="infoBox">
              <span class="white">成员单位数量</span>
              <span class="num">{{ memberUnits }}</span>
            </div>
          </div>
        </div>
        <div class="right_center">
          <div class="left-title subTitleBlue">线上问诊数量</div>
          <div class="olConsultation-top">
            <div
              class="olConsultation-top-bt"
              :class="isMonth ? 'isBtnActived' : ''"
              @click="getOnlineChat"
            >
              本月
            </div>
            <div
              class="olConsultation-top-bt"
              :class="isThreeMonth ? 'isBtnActived' : ''"
              @click="getMutiMonth(3)"
            >
              近3个月
            </div>
            <div
              class="olConsultation-top-bt"
              :class="isHalfYear ? 'isBtnActived' : ''"
              @click="getMutiMonth(6)"
            >
              近半年
            </div>
            <div class="olConsultation-top-input">
              <el-date-picker
                v-model="olConsultationDate"
                type="monthrange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="mini"
                value-format="yyyy-MM"
                :picker-options="pickerOptionsMonth"
                @change="handleConsultationRangeDate"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="chart" id="olConsultation"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入echarts
import * as echarts from "echarts";

export default {
  name: "statistics",
  data() {
    return {
      date: "",
      time: "",
      userAmount: "0",
      olConsultation: "0",
      totalVisits: "0",
      currentMonthVisits: "0",
      memberUnits: "0",
      registerUser: "",
      registerUserList: "",
      visits: "",
      vistitList: "",
      pickerOptionsMonth: {
        disabledDate(month) {
          return (
            month.getTime() > Date.now() - 8.64e6 || month.getFullYear() < 1980
          );
          //  return (month.getFullYear() < 2010 || month.getFullYear() > new Date().getFullYear())
        },
      },
      pickerOptionsYear: {
        disabledDate(year) {
          return (
            year.getFullYear() < 1980 ||
            year.getFullYear() > new Date().getFullYear()
          );
          // return (year.getTime() > Date.now() - 8.64e6);
        },
      },
      userRoleList: "",
      olConsultationDate: "",
      currentMonthTotalChat: [],
      isMonth: false,
      isThreeMonth: false,
      isHalfYear: false,
      isRange: false,
      currentDateFromBtn: "",
      startDate: "",
      endDate: "",
      olConsultationDateList: [],
      olConsultationDateValue: [],
      nowTime: "",
      timeId: "",
    };
  },
  mounted() {
    this.getTime();
    this.showTime();
    this.getOnlineChat();
    this.iniData();
    this.getCurrentTime();
  },
  methods: {
    iniData() {
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + "/api/home/data/static",
      })
        .then((res) => {
          if (res.code == 0) {
            this.userAmount = res.data.userAllCount;
            this.olConsultation = res.data.onlineChatAllCount;
            this.totalVisits = res.data.visitAllCount;
            this.currentMonthVisits = res.data.visitMonthCount;
            this.userRoleList = res.data.userRoleList;
            // console.log("this.userRoleList", this.userRoleList);
            res.data.userRoleList.filter((item) => {
              if (item.key == 7 && item.keyName === "成员单位") {
                this.memberUnits = item.count;
              }
            });
            this.iniChart();
          }
        })
        .catch(() => {
          this.$message.error("数据获取失败");
        });
    },
    // 如果需要让日期选择器的图标在右边就启用它
    floatIconToRight() {
      document
        .getElementsByClassName("el-input__icon")[1]
        .classList.remove("el-range__close-icon");
      document
        .getElementsByClassName("el-input__icon")[1]
        .classList.add("el-icon-date");
    },
    getTime() {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1;
      var date = d.getDate();
      if (d.getHours() < 10) {
        var hour = "0" + d.getHours();
      } else {
        var hour = d.getHours();
      }
      if (d.getMinutes() < 10) {
        var min = "0" + d.getMinutes();
      } else {
        var min = d.getMinutes();
      }

      var sec = d.getSeconds();
      // var day = d.getDay();
      // var week = ["日", "一", "二", "三", "四", "五", "六"];
      switch (d.getDay()) {
        case 1:
          var day = "一";
          break;
        case 2:
          var day = "二";
          break;
        case 3:
          var day = "三";
          break;
        case 4:
          var day = "四";
          break;
        case 5:
          var day = "五";
          break;
        case 6:
          var day = "六";
          break;
        case 7:
          var day = "日";
          break;
      }
      this.date = year + "年" + month + "月" + date + "日";

      this.time = "星期" + day + " " + hour + ":" + min;
    },
    // 获取当前年月
    getCurrentTime() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentYearMonth = year + seperator1 + month;
      var currentYear = year;
      this.registerUser = currentYearMonth;
      this.visits = String(currentYear);
      // console.log("this.visits",this.visits)
    },
    // 初始化图表
    iniChart() {
      this.oLVisitChart();
      this.userChart();
      this.visiterType();
      // this.olConsultationChart();
    },

    // 访问量图表
    oLVisitChart(data) {
      if (this.visits == "") {
        var d = new Date();
        var year = d.getFullYear();
        var data = { year: year };
      } else {
        var data = { year: this.visits };
      }

      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl + "/api/home/data/getVisitStatisticByYear",

        params: data,
      })
        .then((res) => {
          // console.log("访问量图表", res);

          if (res.code == 0) {
            this.vistitList = res.data;
            let getMonth = this.vistitList.thisYearList.map((val) => {
              return val.keyName;
            });
            let getCurrentYearVal = this.vistitList.thisYearList.map((val) => {
              return val.count;
            });
            let increase = this.vistitList.thisYearList.map((val, index) => {
              if (index == 0) {
                return 0;
              } else {
                if (
                  this.vistitList.thisYearList[index - 1].count == 0 &&
                  this.vistitList.thisYearList[index].count == 0
                ) {
                  return 0;
                } else if (this.vistitList.thisYearList[index].count == 0) {
                  return 0;
                } else if (
                  this.vistitList.thisYearList[index - 1].count == 0 &&
                  this.vistitList.thisYearList[index].count != 0
                ) {
                  return Math.round(this.vistitList.thisYearList[index].count);
                } else if (
                  this.vistitList.thisYearList[index - 1].count >
                    this.vistitList.thisYearList[index].count !=
                  0
                ) {
                  return (
                    -(
                      (this.vistitList.thisYearList[index - 1].count -
                        this.vistitList.thisYearList[index].count) /
                      this.vistitList.thisYearList[index - 1].count
                    )
                      // this.vistitList.thisYearList[index - 1].count /
                      // this.vistitList.thisYearList[index].count
                      .toFixed(1) * 100
                  );
                } else {
                  // console.log(this.vistitList.thisYearList[index-1].count,"/",this.vistitList.thisYearList[index].count)
                  return (
                    (
                      (this.vistitList.thisYearList[index].count -
                        this.vistitList.thisYearList[index - 1].count) /
                      this.vistitList.thisYearList[index - 1].count
                    )
                      // this.vistitList.thisYearList[index - 1].count /
                      // this.vistitList.thisYearList[index].count
                      .toFixed(1) * 100
                  );
                }
              }
            });
            // console.log("increase",increase );

            let max = Math.max.apply(null, getCurrentYearVal);
            let min = Math.min(...getCurrentYearVal);
            console.log(
              "max",
              max,
              "min",
              min,
              "increse",
              increase,
              getCurrentYearVal
            );
            var myChart = this.$echarts.init(
              document.getElementById("olVisitChart")
            );

            myChart.setOption({
              legend: {
                data: ["较上月增长", "访问量"],
                textStyle: {
                  fontSize: 13,
                  color: "#fff",
                },
                // right: 164,
                selectedMode: false, //取消图例上的点击事件
                left: 0,
                top: 5,
                itemWidth: 18,
                itemHeight: 7,
                itemGap: 24,
              },
              //    tooltip: {
              //      show: true //显示提示框

              tooltip: {
                trigger: "axis",
                axisPointer: {
                  type: "line", // 默认为直线，可选为：'line' | 'shadow'
                },
                formatter: function (params) {
                  var str =
                    params[0].name + "较上月增长" + params[1].value + "%<br>";
                  for (let item in params) {
                    if (item == 0) {
                      str +=
                        params[item].name + " : " + params[item].value + "<br>";
                    }
                  }

                  return str;
                },
              },

              xAxis: {
                data: getMonth,
                axisLabel: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              yAxis: [
                {
                  type: "value",
                  name: "题⽬数量", //y坐标轴的名字
                  splitLine: {
                    //显⽰分割线
                    show: false,
                  },
                  axisLabel: {
                    textStyle: {
                      color: "#fff",
                    },
                  },
                },
                {
                  type: "value",
                  position: "right",
                  name: "访问量", //y坐标轴的名字
                  splitLine: {
                    //显⽰分割线
                    show: false,
                  },
                  axisLabel: {
                    formatter: "{value}%",
                    textStyle: {
                      color: "#fff",
                    },
                  },
                },
                // {
                //   type: "value",
                //   // name: "正确率",
                //   position: "right",
                //   min: min,
                //   max: max, //控制百分⽐的最⼤最⼩数值
                //   axisLabel: {
                //     formatter: "{value}%", //使图变成百分⽐形式
                //     textStyle: {
                //       color: "#fff",
                //     },

                //   },

                // },
              ],

              series: [
                {
                  color: ["rgba(0, 228, 255, 1)"],
                  name: "访问量",
                  type: "bar",
                  data: getCurrentYearVal,
                },
                {
                  name: "较上月增长",
                  type: "line",
                  symbol: "circle", //折线点设置为实⼼点
                  symbolSize: 6, //折线点的⼤⼩
                  yAxisIndex: 1,
                  itemStyle: {
                    normal: {
                      color: "#FEE17B", //折线点的颜⾊
                      lineStyle: {
                        color: "#FEE17B", //折线的颜⾊
                      },
                    },
                  },

                  data: increase,
                },
              ],
            });
          }
        })
        .catch(() => {
          this.$message.error("数据获取失败");
        });
    },
    // 用户数量图表
    userChart() {
      if (this.registerUser == "") {
        var data = {};
      } else {
        var data = { month: this.registerUser };
      }

      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl +
          "/api/home/data/getUserRegistStatisticByMonth",

        params: data,
      })
        .then((res) => {
          if (res.code == 0) {
            // console.log("register info", res);
            this.registerUserList = res.data;
            const manuChart = echarts.init(
              document.getElementById("userChart")
            );
            var colors = ["#00E4FF", "#0079FE"];
            var dataVal = [
              this.registerUserList.deptCount,
              this.registerUserList.userCount,
            ];

            const option = {
              legend: {
                data: [
                  {
                    name: "企业用户",
                    icon: "rect",
                  },
                  {
                    name: "普通用户",
                    icon: "rect",
                  },
                ],
                textStyle: {
                  fontSize: 13,
                  color: "#fff",
                },
                top: 5,
                left: 0,
                itemWidth: 18,
                itemHeight: 7,
                itemGap: 24,
                selectedMode: false, //取消图例上的点击事件
              },

              tooltip: {
                trigger: "axis",
              },
              xAxis: {
                type: "value",
                min: 0,
                max:
                  this.registerUserList.deptCount >=
                  this.registerUserList.userCount
                    ? this.registerUserList.deptCount + 20
                    : this.registerUserList.userCount + 20,
                axisLabel: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
              yAxis: [
                {
                  type: "category",
                  inverse: true,
                  top: 20,
                  axisTick: {
                    show: false,
                  },
                  axisLine: {
                    show: false,
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: "#fff",
                    },
                  },

                  data: ["企业用户", "普通用户"],
                },
              ],

              series: [
                {
                  name: "注册量",
                  type: "bar",
                  barWidth: 16,
                  showBackground: true,
                  itemStyle: {
                    color: function (p) {
                      return colors[p.dataIndex];
                    },
                  },
                  data: dataVal,
                },
                {
                  name: "企业用户",
                  type: "line",
                  barWidth: 0,
                  showBackground: false,
                  showSymbol: false,
                  itemStyle: {
                    color: "#00E4FF",
                  },
                },
                {
                  name: "普通用户",
                  type: "line",
                  barWidth: 0,
                  showBackground: false,
                  showSymbol: false,
                  itemStyle: {
                    color: "#0079FE",
                  },
                },
              ],
              grid: {
                left: "2%",
                right: "2%",
                bottom: "10%",
                containLabel: true,
              },
            };
            manuChart.setOption(option);
          }
        })
        .catch(() => {
          this.$message.error("数据获取失败");
        });
    },

    visiterType(data) {
      let getUserType = this.userRoleList.map((val) => {
        return val.keyName;
      });
      let getUserAmount = this.userRoleList.map((val) => {
        return { value: val.count, name: val.keyName };
      });
      // console.log(getUserType, getUserAmount);
      const manuChart = echarts.init(document.getElementById("visiterType"));
      const option = {
        legend: {
          // 图例
          data: getUserType,
          selectedMode: false, //取消图例上的点击事件
          x: "center",
          y: "bottom",
          orient: "horizontal",
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            fontSize: 12,
            fontStyle: "normal",
            fontWeight: "normal",
            color: "#CCCCCC",
            backgroundColor: "transparent",
            rich: {
              a: {
                width: 70,
              },
            },
          },
        },
        formatter: function (name) {
          return "{a|" + name + "}";
        },
        title: {
          // 设置饼图标题，位置设为顶部居中
          subtext: "访问总数",
          text: this.totalVisits,
          top: "43%",
          left: "center",
          textStyle: {
            //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
            fontSize: 18,
            fontStyle: "normal",
            fontWeight: "normal",
            color: "#fff",
          },
          subtextStyle: {
            //副标题文本样式{"color": "#aaa"}
            fontSize: 11,
            fontStyle: "normal",
            fontWeight: "normal",
            color: "#fff",
          },
        },
        series: [
          {
            type: "pie",
            labelLine: {
              length: 1,
            },
            label: {
              show: true,
              formatter: "{b} : \n{c} ({d}%)", // b代表名称，c代表对应值，d代表百分比
            },
            radius: ["30%", "40%"], //圆环内半径40%，外半径70%
            data: getUserAmount,
            itemStyle: {
              normal: {
                color: function (colors) {
                  var colorList = [
                    "#fc8251",
                    "#5470c6",
                    "#91cd77",
                    "#ef6567",
                    "#f9c956",
                    "#75bedc",
                  ];
                  return colorList[colors.dataIndex];
                },
              },
            },
          },
        ],
      };
      manuChart.setOption(option);
    },

    olConsultationChart() {
      if (this.isMonth) {
        let getValues = [];
        Object.keys(this.currentMonthTotalChat)
          .sort()
          .forEach((item) => {
            getValues.push(this.currentMonthTotalChat[item]);
          });
        // console.log("getValues", getValues);
        var month = new Date().getMonth() + 1; //获取当前月
        var year = new Date().getFullYear(); //获取当前年
        var data = []; //新建日期数组
        var dataLength = new Date(year, month)
          .toJSON()
          .substring(0, 10)
          .split("-")[2]; //获取当前年月日期最大值
        for (var i = 0; i < dataLength; i++) {
          if (i + 1 < 10) {
            if (month < 10) {
              data.push(String(year) + "0" + String(month) + "0" + (i + 1)); //存入数组
            } else {
              data.push(String(year) + String(month) + "0" + (i + 1)); //存入数组
            }
          } else {
            if (month < 10) {
              data.push(String(year) + "0" + String(month) + (i + 1)); //存入数组
            } else {
              data.push(String(year) + String(month) + (i + 1)); //存入数组
            }
          }
        }
        this.olConsultationDateList = data;
        this.olConsultationDateValue = getValues;
      } else {
        let getValues = [];
        let data = [];
        Object.keys(this.currentMonthTotalChat)
          .sort()
          .forEach((item) => {
            getValues.push(this.currentMonthTotalChat[item]);
            data.push(item);
          });
        // console.log("getValues", getValues, "data", data);

        this.olConsultationDateList = data;
        this.olConsultationDateValue = getValues;
      }
      const manuChart = echarts.init(document.getElementById("olConsultation"));
      const option = {
        title: {},
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(2,184,214)", 
          extraCssText:'padding:20px 10px 20px 10px; text-align:center; width:200px; font-size:16px;',
          textStyle: {
            color: "white", //设置文字颜色
          },
          // formatter: "{b} {s}线上 : {c}"
          formatter: function (params) {
            console.log("params",params)
            var str = params[0].name+"\xa0"+"\xa0"+"\xa0"+params[0].seriesName+':'+"\xa0"+params[0].value ;
            return str;
          },
         
        },
        legend: {
          selectedMode: false, //取消图例上的点击事件
          data: ["线上"],
          bottom: "0%",
          textStyle: {
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: "normal",
            color: "#999999",
          },
          itemWidth: 18,
          itemHeight: 7,
          itemGap: 24,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        // toolbox: {
        //   feature: {
        //     saveAsImage: {},
        //   },
        // },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.olConsultationDateList,
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 14,
              color: "#CCCCCC",
            },
            // interval: 5,
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 14,
              color: "#CCCCCC",
            },
          },
        },
        series: [
          // {
          //    color: '#8ABE78',
          //   name: "线上+线下",
          //   type: "line",
          //   stack: "Total",
          //   data: [] ,
          // },
          {
            color: "#FFCE37",
            name: "线上",
            type: "line",
            stack: "Total",
            symbol: "circle", //折线点设置为实⼼点
            symbolSize: 6,
            data: this.olConsultationDateValue,
          },
        ],
      };

      manuChart.setOption(option);
    },
    changeRegisterUser(event) {
      if (event) {
        this.userChart();
      }
    },
    changeVisits(e) {
      if (e) {
        this.oLVisitChart();
      }
    },
    // 取当前月的咨询量
    getOnlineChat() {
      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl +
          "/api/home/data/getOnlineChatDayCountByMonth",
        //  params: { month: "" },
      })
        .then((res) => {
          if (res.code == 0) {
            this.currentMonthTotalChat = res.data;
            this.isMonth = true;
            this.isThreeMonth = false;
            this.isHalfYear = false;
            this.olConsultationChart();
          }
        })
        .catch(() => {
          this.$message.error("数据获取失败");
        });
    },
    getMutiMonth(index) {
      if (index == 3) {
        // 当前月份
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        this.endDate = year.toString() + "-" + month.toString();

        // 前3个月
        var date1 = new Date();
        date1.setMonth(date1.getMonth() - 2);
        var year1 = date1.getFullYear();
        var month1 = date1.getMonth() + 1;
        month1 = month1 < 10 ? "0" + month1 : month1;
        this.startDate = year1.toString() + "-" + month1.toString();
      } else if (index == 6) {
        // 当前月份
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        this.endDate = year.toString() + "-" + month.toString();

        // 前6个月
        var date1 = new Date();
        date1.setMonth(date1.getMonth() - 5);
        var year1 = date1.getFullYear();
        var month1 = date1.getMonth() + 1;
        month1 = month1 < 10 ? "0" + month1 : month1;
        this.startDate = year1.toString() + "-" + month1.toString();
      }
      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl + "/api/home/data/getOnlineChatMonthCount",
        params: { startMonth: this.startDate, endMonth: this.endDate },
      })
        .then((res) => {
          if (res.code == 0) {
            // this.currentMonthTotalChat = res.data;
            // this.isMonth = true;
            if (index == 3) {
              this.isThreeMonth = true;
              this.isMonth = false;
              this.isHalfYear = false;
              this.isRange = false;
              this.currentMonthTotalChat = res.data;
              this.olConsultationChart();
            } else if (index == 6) {
              this.isHalfYear = true;
              this.isMonth = false;
              this.isThreeMonth = false;
              this.isRange = false;
              this.currentMonthTotalChat = res.data;
              this.olConsultationChart();
            } else if (index == 12) {
              this.isRange = true;
              this.isThreeMonth = false;
              this.isHalfYear = false;
              this.isMonth = false;
              this.currentMonthTotalChat = res.data;
              this.olConsultationChart();
            }
          }
        })
        .catch(() => {
          this.$message.error("数据获取失败");
        });
    },
    handleConsultationRangeDate(e) {
      // console.log(e, e[0]);
      // 开始日期
      this.startDate = e[0];
      //结束日期
      this.endDate = e[1];

      this.getMutiMonth(12);
    },
    sitTime() {
      const d = new Date();
      const h = d.getHours();
      const m = d.getMinutes();
      const s = d.getSeconds();
      time.style.setProperty("--ds", s);
      time.style.setProperty("--dm", m + s / 60);
      time.style.setProperty("--dh", h + m / 60 + s / 3600);
    },
    // 显示当前时间
    timeFormate(timeStamp) {
      let year = new Date(timeStamp).getFullYear();
      let month =
        new Date(timeStamp).getMonth() + 1 < 10
          ? "0" + (new Date(timeStamp).getMonth() + 1)
          : new Date(timeStamp).getMonth() + 1;
      let date =
        new Date(timeStamp).getDate() < 10
          ? "0" + new Date(timeStamp).getDate()
          : new Date(timeStamp).getDate();

      let week = new Date(timeStamp).getDay();
      let weeks = ["日", "一", "二", "三", "四", "五", "六"];
      let getWeek = "星期" + weeks[week];
      // this.nowTime = year + "年" + month + "月" + date + "日 " + getWeek;
      this.nowTime = getWeek;
    },
    showTime() {
      this.timeFormate(new Date());
      this.sitTime();
      this.timeId = setTimeout(this.showTime, 1000 * 60 * 60 * 24); //对日期实施有限制，设置1000可以避免，但是用css就没意义
    },
  },
  beforeDestroy() {
    //实例销毁前清除定时器
    if (this.timeId) {
      clearInterval(this.timeId);
    }
  },
};
</script>
<style scoped lang="less">
.wrap {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background: radial-gradient(circle, #050716, #07064c) !important;
  background-size: cover;
  font-size: 10px;
  height: 100vh;
  overflow: hidden;
  // 页面公共样式
  // 页面蓝色次级标题
  .subTitleBlue {
    font-size: 1.9em;
    font-weight: 400;
    // margin-bottom: 1em;
    color: #02d9fd;
  }
  // 页面白色文字内容
  .white {
    color: #fff;
    // margin-top: 1em;
    // margin-bottom: 1em;
    font-size: 1.8em;
    white-space: nowrap;
  }
  // 页面蓝色数字
  .num {
    font-size: 3.8em;
  }
  .chart {
    width: 100%;
    height: 100%;
  }
  // 页面公共样式结束
  .statisticsTop {
    background-image: url("~@/assets/image/statistics/top.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding: 1.3em 26.5em 3.5em 26.5em;
    padding: 1% 10% 2.5% 10%;
    color: #02d9fd;
    div {
      font-size: 1.6em;
    }
    .time-clock {
      width: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
      .time-clock-wrapper {
        width: 80%;
      }
      .time {
      }
    }
    .left-date {
      width: 15%;
      text-align: center;
    }
    .title {
      width: 70%;
      text-align: center;
      font-size: 3.6em;
      font-weight: bold;
      letter-spacing: 0.2em;
      text-shadow: 0.2em 0.2em 0.9em #01153b;
    }
  }
  .statisticsCenter {
    display: flex;
    flex: 1;
    align-items: center;
    padding: 0.2em;
    justify-content: space-between;
    width: 100%;
    .left {
      width: 30%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;

      .infoBox {
        width: 100%;
        margin-top: 3.8em;
        display: flex;
        justify-content: space-around;
        align-items: center;
        div {
          width: 50%;
          height: 7.1em;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;

          // margin: 2em 5em;
        }
      }
      .infoBox div:nth-child(1) {
        border-right: 1px dashed #fff;
      }

      .leftTop {
        background: url("~@/assets/image/statistics/leftTop.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100%;
        // height: auto;
        flex: 1;
        // min-height: 17.5em;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 10px 20px 20px 20px;
        color: #02d9fd;
        margin-bottom: 20px;
      }
      .leftCenter {
        background: url("~@/assets/image/statistics/leftTop.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center;
        width: 100%;
        // height: auto;
        flex: 1;
        // min-height: 17.5em;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 10px 20px 20px 20px;
        margin-bottom: 20px;
        color: #02d9fd;
      }
      .leftFooter {
        background: url("~@/assets/image/statistics/leftCenter.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100%;
        // height: 56.4em;
        height: 60%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 10px 20px 20px 20px;
        color: #02d9fd;
        margin-bottom: 10px;
        .visit-time-picker-wrap {
          position: relative;
          top: 3em;
          left: 38%;
          z-index: 1001;
          .visit-time-picker {
            /deep/.el-input__inner {
              padding-right: 10px !important;
              background-color: #00e4ff;
              color: #fff !important;
              font-size: 16px;
              height: 30px;
            }
            /deep/.el-input__icon {
              line-height: 30px !important;
              height: 30px;
            }
            /deep/.el-input__prefix {
              color: #fff !important;
            }
            /deep/ .el-input__inner::placeholder {
              color: #fff !important;
            }
            /* 谷歌 */
            /deep/ .el-input__inner::-webkit-input-placeholder {
              color: #fff !important;
            }
            /* 火狐 */
            /deep/.el-input__inner:-moz-placeholder {
              color: #fff !important;
            }
            /*ie*/
            /deep/.el-input__inner:-ms-input-placeholder {
              color: #fff !important;
            }
          }
        }
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      flex: 1;
      height: 100%;
      margin-left: 20px;
      .left-title {
        // font-size: 0.3em;
      }
      &_top {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        color: #02d9fd;
        height: 40%;
        &_one {
          background: url("~@/assets/image/statistics/rightTop.png");
          background-size: 100% 100%;
          width: 40%;
          // height: 32.2em;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          padding: 10px;
        }
        &_two {
          background: url("~@/assets/image/statistics/rightTopRight.png");
          background-size: 100% 100%;
          width: 28%;
          // height: 32.2em;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          padding: 10px;
        }
        &_three {
          background: url("~@/assets/image/statistics/rightTopRight.png");
          background-size: 100% 100%;
          width: 28%;
          // height: 32.2em;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: flex-start;
          padding: 10px;
          .infoBox {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            flex: 1;
            .white {
              // color: #fff;
              // font-size: 0.3em;
            }
            .num {
              // font-size: 0.7em;
            }
          }
        }
        .user-time-picker-wrap {
          position: relative;
          top: 3em;
          left: 35%;
          z-index: 1001;
          .user-time-picker {
            /deep/.el-input__inner {
              padding-right: 10px !important;
              background-color: #00e4ff;
              color: #fff !important;
              font-size: 16px;
              height: 30px !important;
            }
            /deep/.el-input__icon {
              line-height: 30px !important;
              height: 30px;
            }
            /deep/.el-input__prefix {
              color: #fff !important;
            }
            /deep/ .el-input__inner::placeholder {
              color: #fff !important;
            }
            /* 谷歌 */
            /deep/ .el-input__inner::-webkit-input-placeholder {
              color: #fff !important;
            }
            /* 火狐 */
            /deep/.el-input__inner:-moz-placeholder {
              color: #fff !important;
            }
            /*ie*/
            /deep/.el-input__inner:-ms-input-placeholder {
              color: #fff !important;
            }
          }

          // 如果需要让日期选择器的图标在右边就启用它
          // .prefix-icon-class {
          //   display: none;
          // }
        }
      }
      &_center {
        background: url("~@/assets/image/statistics/rightFooter.png");
        background-size: 100% 100%;
        width: 100%;
        margin-top: 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        padding: 10px;
        margin-bottom: 10px;
      }
      .olConsultation-top {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: relative;
        top: 3em;

        right: 4%;
        z-index: 1001;

        .olConsultation-top-bt {
          min-width: 60px;
          line-height: 30px;
          height: 30px;
          text-align: center;
          background: #ffffff;
          border-radius: 2px;
          margin-right: 10px;
          color: #777777;
          cursor: pointer;
        }
        .isBtnActived {
          color: rgb(0, 121, 254);
        }
        .olConsultation-top-input {
          line-height: 30px;
          height: 30px;
          /deep/.el-date-editor {
            line-height: 30px;
            height: 30px;
          }
        }
      }
    }
  }
}

// 时钟样式
@property --h {
  syntax: "<integer>";
  inherits: false;
  initial-value: 0;
}
@property --m {
  syntax: "<integer>";
  inherits: false;
  initial-value: 0;
}
@property --s {
  syntax: "<integer>";
  inherits: false;
  initial-value: 0;
}

.time {
  display: flex;
  align-items: center;
  justify-content: center;
  --step: 60s;
  font-family: Consolas, Monaco, monospace;
  font-size: 16px;
  .date {
    margin-right: 0.1rem;
  }
}
.split {
  animation: shark 1s step-end infinite;
}

.hour::after {
  counter-reset: hour var(--h);
  content: counter(hour, decimal-leading-zero);
  animation: hour calc(var(--step) * 60 * 24) infinite steps(24);
  animation-delay: calc(-1 * var(--step) * var(--dh) * 60);
}
.minitus::after {
  counter-reset: minitus var(--m);
  content: counter(minitus, decimal-leading-zero);
  animation: minitus calc(var(--step) * 60) infinite steps(60);
  animation-delay: calc(-1 * var(--step) * var(--dm));
}
.seconds::after {
  counter-reset: seconds var(--s);
  content: counter(seconds, decimal-leading-zero);
  animation: seconds var(--step) infinite steps(60);
  animation-delay: calc(-1 * var(--step) * var(--ds) / 60);
}
@keyframes hour {
  to {
    --h: 24;
  }
}
@keyframes minitus {
  to {
    --m: 60;
  }
}
@keyframes seconds {
  to {
    --s: 60;
  }
}
@keyframes shark {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/index.vue